// Base interface for Test Kit Order
export interface ITestKitOrder {
    id: number;
    healthcareFacilityID: number;
    orderStatusID: number;
    testKitOrderLines: ITestKitOrderLine[];
}

// Interface for summarized test kit order
export interface ITestKitOrderResume {
    id: number;
    date: string;
    healthcareFacility: string;
    status: string;
    total: number;
}

export class TestKitOrderResume implements ITestKitOrderResume {
    id: number;
    date: string;
    healthcareFacility: string;
    status: string;
    total: number;

    constructor(data: ITestKitOrderResume) {
        this.id = data.id;
        this.date = data.date;
        this.healthcareFacility = data.healthcareFacility;
        this.status = data.status;
        this.total = data.total;
    }
}

// Interface for payload when creating/updating an order
export interface ITestKitOrderPayload {
    id?: number;
    healthcareFacilityID: number;
    orderStatusID: number;
    testKitOrderLines: ITestKitOrderLine[];
}

export class TestKitOrderPayload {
    id?: number;
    healthcareFacilityID: number;
    orderStatusID: number;
    testKitOrderLines: ITestKitOrderLine[];

    constructor(data: ITestKitOrderPayload) {
        this.healthcareFacilityID = data.healthcareFacilityID;
        this.orderStatusID = data.orderStatusID;
        this.testKitOrderLines = data.testKitOrderLines;
    }
}

// Interface for test kit order lines
export interface ITestKitOrderLine {
    id?: number;
    testKitOrderID?: number;
    testKitTypeID: number;
    sampleNumber: string;
    trackingNumber: string;
    batchNumber: string;
    expirationDate: Date;
    price: number;
    qty?: number;
}

export class TestKitOrder implements ITestKitOrder {
    id: number;
    healthcareFacilityID: number;
    orderStatusID: number;
    testKitOrderLines: ITestKitOrderLine[];
    healthcareFacilities: { id: number; name: string }[];
    orderStatus: { id: number; name: string }[];
    testKitTypes: { id: number; name: string; price: number }[];

    constructor(data?: Partial<TestKitOrder>) {
        this.id = data?.id ?? 0;
        this.healthcareFacilityID = data?.healthcareFacilityID ?? 0;
        this.orderStatusID = data?.orderStatusID ?? 0;
        this.testKitOrderLines = data?.testKitOrderLines || [];
        this.healthcareFacilities = data?.healthcareFacilities ?? [{ id: 0, name: 'string' }];
        this.orderStatus = data?.orderStatus ?? [{ id: 0, name: 'string' }];
        this.testKitTypes = data?.testKitTypes ?? [{ id: 0, name: 'string' }];
    }

    get healthcareFacilitiesCombobox(): Array<{ value: string; label: string }> {
        return this.toCombobox(this.healthcareFacilities);
    }

    get orderStatusCombobox(): Array<{ value: string; label: string }> {
        return this.toCombobox(this.orderStatus);
    }

    get testKitTypesCombobox(): Array<{ value: string; label: string }> {
        return this.toCombobox(this.testKitTypes);
    }

    private toCombobox(items: Array<{ id: number; name: string }> = []): Array<{ value: string; label: string }> {
        return items.map(({ id, name }) => ({ value: id.toString(), label: name }));
    }
}
